import { memo, useEffect } from "react";
import PropTypes from "prop-types";
import useTranslation from "trafimage-maps/es/utils/useTranslation";

function AddTranslations({ topics }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    topics?.forEach((topic) => {
      if (topic.translations) {
        Object.entries(topic.translations).forEach(([lang, trans]) => {
          i18n.addResourceBundle(lang, "translation", trans);
        });
      }
    });
  }, [topics, i18n]);

  return null;
}

AddTranslations.propTypes = {
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      translations: PropTypes.object,
    }),
  ),
};

export default memo(AddTranslations);
